import styled from '@emotion/styled';
import {EUndecoratedButton} from 'webapp-lib/Components';

export const DisabledOverlay = styled.div`
  opacity: var(--element-disabled-opacity);
  z-index: var(--zindex-elevated);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  background-color: var(--color-core-white);
`;

export const SubTabButton = styled(EUndecoratedButton)`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: var(--gutter-little) var(--gutter-small);
  text-decoration: none;
  white-space: nowrap;

  ${({active}) => (active ? '' : 'font-weight: var(--font-weight-thin);')}
  ${({active}) => (active ? 'color: var(--color-core-black);' : '')}

  background-color: ${({active}) =>
    active ? 'var(--color-state-active)' : 'transparent'};

  &:hover:not(:disabled, .important) {
    background-color: var(--color-state-hover);
    color: var(--color-core-black);
  }

  &:disabled {
    color: ${({active}) =>
      active ? 'var(--color-core-black);' : 'var(--color-core-link)'};
  }

  &.important {
    color: ${({active}) =>
      active
        ? 'var(--color-core-white)'
        : 'var(--color-notification-important)'};
    background: ${({active}) =>
      active ? 'var(--color-notification-important)' : 'transparent'};

    &:hover {
      background: var(---color-notification-important-hover);
      color: var(--color-core-white);
    }
  }

  &:focus {
    &::before {
      content: ' ';
      position: absolute;
      border: var(--focus-border-width) solid var(--color-core-keyboardfocus);
      border-radius: 2px;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
`;

export const StyledSubTabBar = styled.div<{disabled?: boolean}>`
  position: relative;
  height: 40px;
  display: flex;
  margin: 0;
  padding: 0;
  user-select: none;

  .SubTabBarButton {
    cursor: ${({disabled}): string => (disabled ? 'not-allowed' : 'pointer')};
    margin-left: 0;
  }

  &.full-width {
    width: 100%;
    height: var(--subtabbar-height);
    margin-bottom: var(--gutter);

    .SubTabBarButton {
      flex-grow: 1;
      flex-basis: 0;
      font-weight: var(--button-font-weight);
      font-size: var(--font-size-default);
    }
  }
`;
